import { Component, render } from 'preact';
import Map from '/components/map.jsx';
import * as maptalks from 'maptalks/dist/maptalks.min';
import 'maptalks/dist/maptalks.css';
import { HeatLayer } from 'maptalks.heatmap';
import {round_place} from '/common.jsx';
require('datejs');

const clamp = (num, min, max) => {
  return num <= min ? min : num >= max ? max : num;
}

const date_string_to_date = (date_string) => {
  return new Date(date_string.slice(0, 4), date_string.slice(4, 6) - 1, date_string.slice(6, 8),
    date_string.slice(8, 10), date_string.slice(10, 12), date_string.slice(12, 14))
}

export default class MapMapTalks extends Map {

componentDidMount() {

  this.map_layer = new maptalks.TileLayer('base', {
    urlTemplate: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png',
    subdomains: ["a","b","c","d"],
    //attribution: '&copy; <a href="http://osm.org">OpenStreetMap</a> contributors, &copy; <a href="https://carto.com/">CARTO</a>'
  });

  let map_layer = this.map_layer;

  this.map = new maptalks.Map('map', {
    center: [-122.6734196, 45.5153566],
    zoom: 14,
    zoomControl : true, // ignored in a canvas container
    scaleControl : true, // ignored in a canvas container
    dragPitch : true,
    dragRotate : true,
    fpsOnInteracting : 30,
    maxVisualPitch : 40,
    hitDetect: false,
    baseLayer: map_layer,
    maxZoom: 20
  });

  this.heat_layer = new HeatLayer('heat').addTo(this.map);
  this.arrow_layer = new maptalks.VectorLayer('arrows').addTo(this.map);
  

  
  this.radius_robot = new maptalks.Circle([-122.6734196, 45.5153566], 30,{
    symbol: {
      lineColor: '#34495e',
      lineWidth: 2,
      polygonFill: '#1bbc9b',
      polygonOpacity: 0.4
    }
  })

  this.radius_wtc = new maptalks.Circle([-122.67479919130227, 45.51588174426741], 30,{
    symbol: {
      lineColor: '#C14953',
      lineWidth: 2,
      polygonFill: '#E1BB80',
      polygonOpacity: 0.4
    }
  })

  this.radius_dock = new maptalks.Circle([-122.6728165017063, 45.51524140599939], 30,{
    symbol: {
      lineColor: '#DC851F',
      lineWidth: 2,
      polygonFill: '#7E5920',
      polygonOpacity: 0.4
    }
  })
  this.radius_layer = new maptalks.VectorLayer('radius')
    .addGeometry([this.radius_robot, this.radius_wtc, this.radius_dock])
    .addTo(this.map);

  this.graph_data = {
    labels: ['One', 'Two', 'Three',],
    datasets: [
      {
        label: '# of Locations Visited',
        data: [0,0,0],
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };
}

set_map = (map_name) => {
  const { map_layer, providers } = this;
  let options = map_layer.options;
  let map = providers[map_name];

  options.urlTemplate = map.url;
  this.map.options.maxZoom = map.maxZoom;
  map_layer.clear();
  //options.attribution = map.attribution;
}

populate_user_map(){
  const id = p.dimensions[3]+p.dimensions[4]+p.dimensions[5];
  if (that.users_dict[id] == undefined) {
    that.users_dict[id] = {
      points:[{x:lat, y:long, time:time}],
      time_dis:time_dis
    };
  }else{
    that.users_dict[id].points.push({x:lat, y:long, time:time});
  }
}

generate_heatmap_data({
  dataset,
  current_time,
  time_padding_ms,
  precision=100000,
  dimension_indices={lat:0, long:1, time:2, id:[3,4,5,6]},
  test

}) {
  const data = [];
  let hottest_point;

  dataset.forEach((p) => {
    const lat = Number(p.dimensions[dimension_indices.lat]);
    const long = Number(p.dimensions[dimension_indices.long]);
    const time = date_string_to_date(p.dimensions[dimension_indices.time]);
    if (isNaN(time)) {
      return;
    }
    
    let time_dis = 0;
    if (current_time) {
      time_dis = Math.abs(current_time.getTime() - time.getTime())/(time_padding_ms);
      time_dis = clamp(time_dis, 0, 1);
      console.log(time_dis);
    }

    if (time_dis > 0.99) {
      return;
    }
    const lat_rounded = round_place(lat, precision);
    const long_rounded = round_place(long, precision);

    const point_rounded_value = data.find(point => (point[0] == long_rounded && point[1] == lat_rounded));

    if (point_rounded_value == undefined) {
      const point = [long_rounded, lat_rounded, 1 - time_dis];
      data.push(point);
      if (hottest_point == undefined) {
        hottest_point = point;
      }
    }
    else {
      point_rounded_value[2] += 1 - time_dis;
      if (point_rounded_value[2] > hottest_point[2]) {
        hottest_point = point_rounded_value;
      }
    }
  });

  return {data: data, hottest_point: hottest_point};
};

update_heatmap() {

}

generate_user_movement_data({
  dataset,
  current_time,
  time_padding_ms,
  dimension_indices={lat:0, long:1, time:2, id:[3,4,5,6]},
  visit_radii
}) {
  const data = {};

  dataset.forEach((p) => {
    const lat = Number(p.dimensions[dimension_indices.lat]);
    const long = Number(p.dimensions[dimension_indices.long]);
    const time = date_string_to_date(p.dimensions[dimension_indices.time]);
    if (isNaN(time)) {
      return;
    }
    let id = "";
    dimension_indices.id.forEach((i) => {
      id += p.dimensions[i];
    });
    //console.log(id);

    let time_dis = 0;
    if (current_time) {
      time_dis = (Math.abs(current_time.getTime() - time.getTime()))/(time_padding_ms);
      time_dis = clamp(time_dis, 0, 1);
    }

    if (time_dis > 0.99) {
      return;
    }



    if (data[id] == undefined) {
      data[id] = {
        points:[{x:lat, y:long, time:time}],
        time_dis:time_dis,
        visited:{}
      };
    }else{
      data[id].points.push({x:lat, y:long, time:time});
      data[id].time_dis = (data[id].time_dis+time_dis)/2.0;
    }
    
    Object.entries(visit_radii).forEach(([key,value]) => {
      if (value.containsPoint(new maptalks.Coordinate([ long, lat ]))) {
        data[id].visited[key] = true;
        //console.log(data[id].visited);
      }
    });

  });

  return {data: data};
};

populate_arrow_layer({
  dataset,
  arrow_layer,
  current_time,
}){

  const arrows = [];

  const options = {
    arrowStyle : [3, 4], // arrow-style : now we only have classic
    smoothness : 0.05,
    arrowPlacement : 'vertex-last', // arrow's placement: vertex-first, vertex-last, vertex-firstlast, point
    visible : true,
    editable : true,
    cursor : null,
    draggable : false,
    dragShadow : false, // display a shadow during dragging
    drawOnAxis : null,  // force dragging stick on a axis, can be: x, y
    symbol: {
      'lineColor' : '#ffffff',
      'lineWidth' : 2,
      'lineOpacity' : 0.5
    }
  };
  
  const graph_data = [0,0,0];
  Object.values(dataset).forEach((data) => {
    let arrow_points = [];
  

    data.points.sort(function(a,b){return a.time.getTime() - b.time.getTime()});

    data.points.forEach((p) => {
      arrow_points.push([p.y, p.x]);
    });

    if (arrow_points.length > 1 && arrow_points.length < 100) {
      let this_options = {...options};
      this_options.symbol['lineOpacity'] = (1.0 - data.time_dis)*0.5;
      this_options.symbol['opacity'] = (1.0 - data.time_dis)*0.5;
      let color = '#ffffff';
      const len = Object.values(data.visited).length;
      if (len > 0) {
        if (len == 1) {
          color = 'red';
          graph_data[0] += 1;
        } else if (len ==2) {
          color = 'yellow';
          graph_data[1] += 1;
        }
        else if (len ==3) {
          color = 'green';
          graph_data[2] += 1;
        }
      }

      this_options.symbol['lineColor'] = color;
      const arrow = new maptalks.LineString(arrow_points, this_options);
      //console.log(arrow_points.length);

      arrows.push(arrow);
    }
  });

  arrow_layer.clear();
  arrow_layer.addGeometry(arrows);

  return graph_data;
}

update_movement_arrows(){}

update = () => {

};

update_ranged_data = ({
  dataset,
  dimension_indices={time:2, session_count:5, entry:7,},
}) => {
  const that = this;
  const { handle_input, input } = this.props;

  that.min_time = new Date(`${input.gapi_date_start}T00:00:00`);
  that.max_time = new Date(`${input.gapi_date_end}T00:00:00`);

    that.time_range_start_milli = (that.max_time.getTime() - that.min_time.getTime())*input.hm_time_range[0];
    that.time_range_end_milli = (that.max_time.getTime() - that.min_time.getTime())*input.hm_time_range[1];
  

    that.time_start = that.min_time.clone().add({milliseconds:that.time_range_start_milli});
    
    that.time_end = that.min_time.clone().add({milliseconds:that.time_range_end_milli});
    that.time_value = that.min_time.clone().add({milliseconds:((that.time_range_end_milli-that.time_range_start_milli)*input.hm_time + that.time_range_start_milli)});


  const dataset_ranged = [];

  dataset.forEach((p) => {
    //console.log(p.dimensions[dimension_indices.time]+"01");
    const time = date_string_to_date(p.dimensions[dimension_indices.time]);
    //return if date is invalid
    if (isNaN(time) || isNaN(that.time_start)) {
      return;
    }
    //console.log(time);

    const entry = p.dimensions[dimension_indices.entry];
    const session_count = p.dimensions[dimension_indices.session_count];
    if (time.isBefore(that.time_start) || time.isAfter(that.time_end)) {
      return;
    }
    if (!(entry == "/it-wlf/?entry=1" || entry =="/it-wlf/?entry=2" || entry =="/it-wlf/?entry=3")) {
      return;
    }
    if (session_count > 10) {
      return;
    }
    //console.log(session_count);
    dataset_ranged.push(p);
  });

  return dataset_ranged;
}

render () {
  const { handle_input, ga_gps_json, input, styles, update_graph_data } = this.props;
  const { input_changed, map, set_map, generate_heatmap_data, update_ranged_data, generate_user_movement_data, populate_arrow_layer } = this;

  const that = this;

  const map_container = <div id='map' style='height:100%; width:100%; z-index:0'></div>

  if (!ga_gps_json) {
    return map_container;
  }

  if (input_changed('map_provider')) {
    set_map(input.map_provider);
  }
 // console.log(input.hm_time);
  that.ranged_data = update_ranged_data({
    dataset:ga_gps_json.reports[0].data.rows,
    dimension_indices:{time:2, session_count:5, entry:7},
  });

  that.heatmap_data = generate_heatmap_data({
    dataset: that.ranged_data,
    current_time: (input.hm_time > 0) ? that.time_value : undefined,
    time_padding_ms: input.hm_time_padding*60.0*1000.0,
    precision: input.hm_prec,
    dimension_indices: {lat:0, long:1, time:2, id:[3,4,5,6]},
  });

  
  that.heat_layer.setData(that.heatmap_data.data);
  that.heat_layer.options = {
    max: (that.heatmap_data.hottest_point) ? that.heatmap_data.hottest_point[2] : 1.0,
    minOpacity: 0.01,
    radius: input.hm_scale,
    heatValueScale: input.hm_scale,
  }
  that.heat_layer.redraw();
  
  that.user_movement_data = generate_user_movement_data({
    dataset: that.ranged_data,
    current_time: (input.hm_time > 0) ? that.time_value : undefined,
    time_padding_ms: input.hm_time_padding*60.0*1000.0,
    dimension_indices: {lat:0, long:1, time:2, id:[3,4,5,6]},
    visit_radii: {"robot":that.radius_robot, "wtc":that.radius_wtc, "dock":that.radius_dock }
  });

  this.graph_data.datasets[0].data = populate_arrow_layer({
    dataset: that.user_movement_data.data,
    arrow_layer: that.arrow_layer,
    current_time: (input.hm_time > 0) ? that.time_value : undefined,
  });
  
  if (input.map_recenter && that.heatmap_data.hottest_point) {
    that.map.setCenter([that.heatmap_data.hottest_point[0], that.heatmap_data.hottest_point[1]]);
  }

  if (input_changed('hm_time') || input_changed('hm_time_range') || input_changed('hm_time_padding')) {
    //console.log(this.graph_data);
    update_graph_data(this.graph_data);
  }

  return map_container;
}

} //MapMapTalks
  